import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { UserInfo } from 'interfaces';

const defaultUser = { user_uuid: '', username: '' };
export interface IUserState {
  userInfo: UserInfo;
  authenticated: boolean;
  isLoginDisabled: boolean;
}

const initialState: IUserState = {
  userInfo: defaultUser,
  authenticated: false,
  isLoginDisabled: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserAction: (state, action: PayloadAction<{ user: UserInfo }>) => {
      state.userInfo = { ...state.userInfo, ...action.payload.user };
    },
    updateUserAuthentication: (state, action: PayloadAction<boolean>) => {
      state.authenticated = action.payload;
    },
    disableLogin: (state, action: PayloadAction<boolean>) => {
      state.isLoginDisabled = action.payload;
    },
    cleanupUser: state => {
      state.userInfo = defaultUser;
    },
  },
});

export const { updateUserAction, updateUserAuthentication, disableLogin, cleanupUser } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
